import * as React from "react";

const JAFlag = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		width="25px"
		height="16px"
		viewBox="0 0 25 16"
		enableBackground="new 0 0 25 16"
		xmlSpace="preserve"
		{...props}
	>
		<path fill="#FFFFFF" d="M0,0h25v16H0V0z" />
		<path
			fill="#BC002D"
			d="M17.5,8c0,2.761-2.238,5-5,5c-2.761,0-5-2.239-5-5c0-2.761,2.239-5,5-5C15.262,3,17.5,5.239,17.5,8z"
		/>
	</svg>
);

export default JAFlag;